import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import * as es6printJS from "print-js";
import { environment } from "src/environments/environment";
import { calcularValorAdesao } from "src/utils/adesao.utils";
import { Sale } from "../../models/sale";
import { SaleSummary } from "../../models/sale-summary";
import { getSignatureImageUrl, getSignatureUrl, getSignatureStatus } from "../../utils/signature.utils";

@Component({
  selector: "app-sale-summary",
  templateUrl: "./sale-summary.component.html",
  styleUrls: ["./sale-summary.component.scss"],
})
export class SaleSummaryComponent implements OnInit {
  env;
  saleSummary: SaleSummary;

  @Input() sale: Sale;
  @Input() saleRecord: any;

  @Input() printSummary: boolean;
  @Output() printSummaryChange = new EventEmitter<boolean>();

  constructor() {
    this.env = environment;
  }

  ngOnInit() {
    this.getSaleSummaryData(this.env.selected.cnpj);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.printSummary && changes.printSummary.currentValue) {
      this.htmlToPdf();
      this.printSummary = false;
      this.printSummaryChange.emit(this.printSummary);
    }
  }

  getSaleSummaryData(cnpj: string) {
    const logoUrl = `https://image-virtus.sfo2.digitaloceanspaces.com/assets/images/${cnpj}/comprovante/logo.png`;

    if (this.sale) {
      this.saleSummary = {
        logo: logoUrl,
        vendedor: this.sale.vendedor,
        empresa: this.env.selected,
        titular: this.sale.titular,
        dependentes: this.sale.beneficiarios,
        plano: {
          ...this.sale.plano,
          valor_adicionais: this.sale.valor_adicionais,
          valor_itens_adicionais: this.sale.valor_itens_adicionais,
          valor_plano: this.sale.valor_plano,
          valor_total: this.sale.valor_total,
        },
        pagamento: {
          forma_pagto: this.sale.forma_pagto_parcelas,
          primeiro_vencimento: this.sale.primeiro_vencimento,
          adesao: this.sale.adesao,
          recorrencia: this.sale.recorrencia,
          adiantamento: this.sale.adiantamento,
        },
        termos: this.sale.termo,
        assinatura: this.getSignatureImageUrl(),
        assinatura_link: this.getSignatureUrl(),
        assinatura_status: this.getSignatureStatus(),
      };
    }
  }

  htmlToPdf() {
    const backTitle = document.title;
    document.title = `${this.sale.titular.nome.replace(/\s/g, "-")}-${this.sale.titular.cpfcnpj}`;

    es6printJS({
      printable: "contentToPrint",
      type: "html",
      targetStyles: ["*"],
      documentTitle: `${this.sale.titular.nome.replace(/\s/g, "-")}-${this.sale.titular.cpfcnpj}`,
      onPrintDialogClose: () => (document.title = backTitle),
    });
  }

  getRelatives(type: string) {
    switch (type) {
      case "CO":
        return "Cônjuge";
        break;
      case "FI":
        return "Filho(a)";
        break;
      case "IR":
        return "Irmão(a)";
        break;
      case "NE":
        return "Neto(a)";
        break;
      case "PA":
        return "Pai";
        break;
      case "MA":
        return "Mãe";
        break;
      case "OU":
        return "Outros";
        break;
      case "SO":
        return "Sogro(a)";
      case "SC":
        return "Segundo cônjuge";
      case "TU":
        return "Tutelado(a)";
      case "CU":
        return "Curatela";
      case "EN":
        return "Entiado(a)";
      case "AG":
        return "Agregado(a)";

      default:
        return "";
        break;
    }
  }

  getSignatureImageUrl(): string {
    return getSignatureImageUrl(this.sale);
  }

  getSignatureUrl(): string {
    return getSignatureUrl(this.saleRecord);
  }

  getSignatureStatus(): string {
    return getSignatureStatus(this.saleRecord);
  }

  getDependentType(type: string) {
    switch (type) {
      case "1":
        return "Beneficiário";
        break;
      case "2":
        return "Agregado";
        break;
      case "3":
        return "Títular";
        break;

      default:
        return "";
        break;
    }
  }

  getValorAdesao(): number {
    const pagamento = this.saleSummary && this.saleSummary.pagamento;
    const adesao = pagamento && pagamento.adesao;
    return calcularValorAdesao(adesao && adesao.valor, adesao && adesao.desconto);
  }
}
